// extracted by mini-css-extract-plugin
export default {"parent":"goodToKnowSection_parent__jbx1S","parentTitle":"goodToKnowSection_parentTitle__XS6sf"};